import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';
import { CollaboComponent } from './views/collabo/collabo.component';
import { MessageComponent } from './views/collabo/message.component';
import { PaymentComponent } from './views/collabo/payment.component';


import { ForgotComponent } from './views/forgot/forgot.component';
import { LoginComponent } from './views/login/login.component';
import { PasswordchangeComponent } from './views/passwordchange/passwordchange.component';
import { RegisterComponent } from './views/register/register.component';
import { ResetComponent } from './views/reset/reset.component';
import { SubcriptionComponent } from './views/subcription/subcription.component';
import { ProfileSetupComponent } from './views/profile-setup/profile-setup.component';

import { TermsConditionsComponent } from './views/terms-conditions/terms-conditions.component';
import { QuotationComponent } from './views/collabo/quotation.component';

import { InitiatorModule } from './views/initiator/initiator.module';
import { InitiatorDashboardComponent } from './views/initiator/initiatordashboard.component';
import { InitiatorMessageComponent } from './views/initiator/initiatormessage.component';
import { PayComponent } from './views/initiator/pay.component';
import { InitiatorChangePwdComponent } from './views/initiator/initiatorchangepwd.component';
import { MessagesComponent } from './views/initiator/messages/messages.component';
import { InitiatorCollaboComponent } from './views/initiator/initiatorcollabo.component';
import { InitiatorPostcollaboComponent } from './views/initiator/initiatorpostcollabo.component';
import { CostComponent } from './views/initiator/cost.component';
import { MyaccountComponent } from './views/collabo/myaccount.component';
import { LocationComponent } from './views/admin/location/location.component';
import { AdminprofileComponent } from './views/admin/adminprofile/adminprofile.component';
import { DashboardComponent } from './views/admin/dashboard/dashboard.component';
import { SkillsComponent } from './views/admin/skills/skills.component';
import { Category1Component } from './views/admin/category1/category1.component';
import { UsersComponent } from './views/admin/users1/users.component';
import { AddUsersComponent } from './views/admin/users1/addusers.component';
import { CollabosComponent } from './views/admin/collabos/collabos.component';
import { AdminSignupComponent } from './views/admin/admin-signup/admin-signup.component';
import { RolesComponent } from './views/admin/roles/roles.component';
import { CmsComponent } from './views/admin/cms/cms.component';
import { ChangePasswordComponent } from './views/admin/change-password/change-password.component';
import { EmailComponent } from './views/admin/email/email.component';
import { PlansComponent } from './views/admin/plans/plans.component';
import { AdminForgotpasswordComponent } from './views/admin-forgotpassword/admin-forgotpassword.component';
import { AdminLoginComponent } from './views/admin-login/admin-login.component';
import { OverviewComponent } from './views/collabo/overview.component';
import { HomepageComponent } from './views/homepage/homepage.component';
import { PostcollaboComponent } from './views/postcollabo/postcollabo.component';
import { PrivacypolicyComponent } from './views/privacypolicy/privacypolicy.component';
import { EmailverificationComponent } from './views/emailverification/emailverification.component';
import { ServicechargeComponent } from './views/admin/servicecharge/servicecharge.component';
import { BidacollaboComponent } from './views/bidacollabo/bidacollabo.component';
import { FinancialDashboardComponent } from './views/admin/financial-dashboard/financial-dashboard.component';
export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {path:'home', component:HomepageComponent},
  {path:'postcollabo',component:PostcollaboComponent},
  {path:'forget', component:ForgotComponent},
  {path:'login', component:LoginComponent},
  {path:'reset/:userID/:email', component:ResetComponent},
  {path:'tc', component:TermsConditionsComponent},
  {path:'pp', component:PrivacypolicyComponent},
  {path:'passwordchange/:userid',component:PasswordchangeComponent},
  
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register Page'
    }
  },
  {path:'emailverification/:userid',component:EmailverificationComponent},
  {path:'subscribe/:userID/:tabvalue/:subscriptionid',component:SubcriptionComponent},
  {path:'profilesetup/:userID/:tabvalue', component:ProfileSetupComponent },
  {path:'admin',component:AdminLoginComponent},
  {path:'admin-forgotpassword',component:AdminForgotpasswordComponent},
  {
    path: 'bidacollabo',
    // loadChildren: () => import('./views/collabo/collabo.module').then(m => m.CollaboModule)
    component: BidacollaboComponent,
    data: {
      title: 'Bidacollabo'
    },
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path:'overview',
        component:OverviewComponent,
        data: {
          title: 'Invoice'
        },
      },
    
       {
        path: 'initatordashboard',
        component:  InitiatorDashboardComponent,
        data: {
          title: 'Dashboard'
        },
      },
      {
        path:'initatormessage',
        component:InitiatorMessageComponent,
        data: {
          title: 'Messages'
        },
    },
    
  {path:'initatorhead/messages/:userID/:chatid/:collaboid',
  component:MessagesComponent,
  data: {
    title: 'Messages'
  },
 
  },
    {
      path: 'initatorcollabo/:collaboID/:screen', // child route path
      component: InitiatorCollaboComponent, // child route component that the router renders
      data: {
        title: 'Collabos'
      },
    },
    {
      path: 'initatorpostcollabo/:collaboID/:type',
      component: InitiatorPostcollaboComponent, // another child route component that the router renders
      data: {
        title: 'Post collabo'
      },
    },
    {
        path: 'cost',
        component: CostComponent, // another child route component that the router renders
        data: {
          title: 'Cost'
        },
      },
    {path:'pay',
     component: PayComponent,
     data: {
      title: 'Invoice'
    },
   },
    // {path:'initatormyaccount', component: MyaccountComponent},
    {path:'changepassword', 
    component: InitiatorChangePwdComponent,
    data: {
      title: 'Change password'
    },
   },
    {path:'messages/:userID/:chatid/:collaboid',
    component:MessagesComponent,
    data: {
      title: 'Messages'
    },
    },
    
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      
     

{
        path: 'collabo',
        // loadChildren: () => import('./views/collabo/collabo.module').then(m => m.CollaboModule)
        component: CollaboComponent,
        data: {
          title: 'Collabo'
        },
      },
       
{
  path: 'quote',
  // loadChildren: () => import('./views/collabo/collabo.module').then(m => m.CollaboModule)
  component: QuotationComponent,
  data: {
    title: 'Quotations'
  },
},
      
      {
        path: 'message',
        // loadChildren: () => import('./views/collabo/collabo.module').then(m => m.CollaboModule)
        component: MessageComponent,
        data: {
          title: 'Messages'
        },
      },
      
      {
        path: 'payment',
        // loadChildren: () => import('./views/collabo/collabo.module').then(m => m.CollaboModule)
        component: PaymentComponent,
        data: {
          title: 'Dashboard'
        },
      },
      {
        path: 'postcollabo',
        // loadChildren: () => import('./views/collabo/collabo.module').then(m => m.CollaboModule)
        component: PostcollaboComponent,
        data: {
          title: 'Postcollabo'
        },
      },
     
      {
        path: 'myaccount',
        // loadChildren: () => import('./views/collabo/collabo.module').then(m => m.CollaboModule)
        component: MyaccountComponent,
        data: {
          title: 'myaccount'
        },
      },
      {
        path: 'location', // child route path
        component: LocationComponent, // child route component that the router renders
        data: {
          title: 'Location'
        },
      },
       {
        path: 'adminprofile', // child route path
        component: AdminprofileComponent, // child route component that the router renders
        data: {
          title: 'AdminProfile'
        },
      },
      {
        path: 'admindashboard', // child route path
        component: DashboardComponent, // child route component that the router renders
        data: {
          title: 'Dashboard'
        },
      },
      {
        path: 'financialdashboard', // child route path
        component: FinancialDashboardComponent, // child route component that the router renders
        data: {
          title: 'Financial Dashboard'
        },
      },
      {
        path:'skills',
        component:SkillsComponent,
        data: {
          title: 'Skills'
        },
      },
      {
        path:'category',
        component:Category1Component,
        data: {
          title: 'Category'
        },
      },
      {
        path:'users',
        component:UsersComponent,
        data: {
          title: 'Users'
        },
      },
     
      {
        path:'addusers',
        component:AddUsersComponent,
        data: {
          title: 'Addusers'
        },
      },
      {
        path:'collabos',
        component:CollabosComponent,
        data: {
          title: 'Collabos'
        },
      },
       {
        path:'admin-signup',
        component:AdminSignupComponent,
        data: {
          title: 'AdminSignup'
        },
      },
      {
        path:'roles',
        component:RolesComponent,
        data: {
          title: 'Roles'
        },
      },
      {
        path:'cms',
        component:CmsComponent,
        data: {
          title: 'CMS'
        },
        
      },
      {
        path:'csc',
        component:ServicechargeComponent,
        data: {
          title: 'Collaborator service charge'
        },
        
      },
       {
        path:'adminchangepassword',
        component:ChangePasswordComponent,
        data: {
          title: 'ChangePassword'
        },
      },
      {
        path:'emails',
        component:EmailComponent,
        data: {
          title: 'Emails'
        },
      },
{
        path:'plans',
        component:PlansComponent,
        data: {
          title: 'Plans'
        },
    }
    ]
  },
  
  
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
